export const TIERS = [
  { key: "cost",        label: "Costo",        color: "#52525B" },
  { key: "min",         label: "Mínimo",       color: "#E0000F" },
  { key: "reseller",    label: "Reventa",      color: "#7E57C2" },
  { key: "marketplace", label: "Distribuidor", color: "#FFC000" },
  { key: "store",       label: "Tienda",       color: "#002FA7" },
];

export const CAT_COLORS = ["#002FA7", "#00873D", "#FFC000", "#E0000F", "#1E88E5", "#7E57C2", "#FF7043", "#26A69A", "#8D6E63", "#5C6BC0"];

export const convert = (usd, cur, rate) => (cur === "MXN" ? Number(usd || 0) * rate : Number(usd || 0));

export const money = (v, cur, decimals = 2) =>
  `${cur === "USD" ? "$" : "MX$"}${Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;

export const compact = (v, cur) => {
  const n = Number(v || 0);
  const abs = Math.abs(n);
  const s = abs >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : abs >= 1e3 ? `${(n / 1e3).toFixed(abs >= 1e5 ? 0 : 1)}k` : `${Math.round(n)}`;
  return `${cur === "USD" ? "$" : "MX$"}${s}`;
};
